import { render, staticRenderFns } from "./ReplacementRuleConfigs.vue?vue&type=template&id=44314bdd&scoped=true"
import script from "./ReplacementRuleConfigs.vue?vue&type=script&lang=js"
export * from "./ReplacementRuleConfigs.vue?vue&type=script&lang=js"
import style0 from "./ReplacementRuleConfigs.vue?vue&type=style&index=0&id=44314bdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44314bdd",
  null
  
)

export default component.exports